var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoostModeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.97 4 4 12.97 4 24C4 35.03 12.97 44 24 44C35.03 44 44 35.03 44 24C44 12.97 35.03 4 24 4ZM24 42C14.08 42 6 33.92 6 24C6 14.08 14.08 6 24 6C33.92 6 42 14.07 42 24C42 33.93 33.92 42 24 42Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.61 23.5V23.45C29.1 22.87 30.07 21.65 30.07 19.56C30.07 16.66 28.17 15 24.34 15H17.25V33H24.54C28.95 33 30.75 31.03 30.75 27.82C30.75 25.47 29.63 24.05 27.61 23.5ZM20.49 17.86H24.22C26.05 17.86 26.85 18.48 26.85 20.16C26.85 21.84 26.07 22.51 24.36 22.51H20.49V17.85V17.86ZM24.56 30.22H20.49V25.04H24.49C26.54 25.04 27.39 25.81 27.39 27.56C27.39 29.58 26.44 30.22 24.56 30.22Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoostModeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Boost_Mode_Icon.3868225f60bbaa41b8850552b7bc8a9e.svg";